module.exports = __webpack_public_path__ + "static/media/about_content_3.ac521b6e.png";